import { render } from "./tabToggle.vue?vue&type=template&id=49e2e894&scoped=true"
import script from "./tabToggle.vue?vue&type=script&lang=js"
export * from "./tabToggle.vue?vue&type=script&lang=js"

import "./tabToggle.vue?vue&type=style&index=0&id=49e2e894&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e2e894"]])

export default __exports__